// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chat-setting"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.499 16.9954C21.499 18.3762 20.3797 19.4954 18.999 19.4954C17.6183 19.4954 16.499 18.3762 16.499 16.9954C16.499 15.6147 17.6183 14.4954 18.999 14.4954C20.3797 14.4954 21.499 15.6147 21.499 16.9954Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21.5 10V3H2.5V20.5L6.5 17H12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.9989 14.4954C17.6182 14.4954 16.4989 15.6147 16.4989 16.9954C16.4989 18.3762 17.6182 19.4954 18.9989 19.4954C20.3796 19.4954 21.4989 18.3762 21.4989 16.9954C21.4989 15.6147 20.3796 14.4954 18.9989 14.4954ZM18.9989 14.4954V13.5M18.9989 20.4954V19.5M16.8319 15.7467L15.9698 15.2489M22.028 18.7467L21.1659 18.2489M21.1659 15.7466L22.028 15.2489M15.9697 18.7466L16.8318 18.2489","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChatSettingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-setting',
    ref,
    icon: element,
  },
));

ChatSettingIcon.displayName = 'ChatSettingIcon';

export default ChatSettingIcon;
